module.exports = __webpack_public_path__ + "img/TR.4e34259f.webp";